import store from '@/store'
import useNotifications from '@/composables/useNotifications'
import { useRouter } from '@core/utils/utils'
import { ref } from '@vue/composition-api'
import i18n from '@/libs/i18n'
import { useLambda } from '@/views/habit/awsLambda'
import { oid } from '@/helpers/mongoHelpers'
import { hasPermission } from '@/composables/usePermission'
import useAuditLog from '@/composables/useAuditLog'

export default function useCompanyAdd() {
  const { showSuccessMessage, showErrorMessage } = useNotifications()
  const { router } = useRouter()
  const { createItem } = useLambda()
  const { createInitialAuditEntry } = useAuditLog()
  const userData = store.state?.userStore?.userData
  const company = ref({})
  const isSubmitting = ref(false)
  const collection = 'company'

  const create = async (data) => {
    if (!hasPermission('organization-companies', 'create')) {
      showErrorMessage(i18n.t('message.you_are_not_authorized'))
      return
    }

    isSubmitting.value = true

    try {
      const payload = {
        client_id: oid(userData.client.$oid),
        name: data.name.value,
        economicCrimesLawMainInvestigators: data.economicCrimesLawMainInvestigators?.value?.map(id => oid(id)) || [],
        economicCrimesLawSecondaryInvestigators: data.economicCrimesLawSecondaryInvestigators?.value?.map(id => oid(id)) || [],
        karinLawMainInvestigators: data.karinLawMainInvestigators?.value?.map(id => oid(id)) || [],
        karinLawSecondaryInvestigators: data.karinLawSecondaryInvestigators?.value?.map(id => oid(id)) || [],
        ethicalSituationsMainInvestigators: data.ethicalSituationsMainInvestigators?.value?.map(id => oid(id)) || [],
        ethicalSituationsSecondaryInvestigators: data.ethicalSituationsSecondaryInvestigators?.value?.map(id => oid(id)) || [],
        history: [createInitialAuditEntry()],
      }

      await createItem({ collection, payload })

      showSuccessMessage(i18n.t('message.company_added'))
    } catch (error) {
      console.log(error)
      showErrorMessage(i18n.t('message.company_add_error'))
    } finally {
      router.push({ name: 'organization-company-list' })
      isSubmitting.value = false
    }
  }

  return {
    create,
    company,
    isSubmitting,
  }
}
